import styled from 'styled-components';
import theme from 'shared/theme';

export const Action = styled.div`
  text-align: left;
  cursor: pointer;
  margin-bottom: 5px;
  &:hover {
    color: ${theme.community.coolGrey};
  }
`;
